'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import EPDragHandle from './EPDragHandle';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITruncateMultiline from 'UIComponents/text/UITruncateMultiline';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import styled from 'styled-components';
import { OBSIDIAN, BATTLESHIP, EERIE, OLAF, CIRRUS } from 'HubStyleTokens/colors';
import { memoize } from 'underscore';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DEFAULT_TILE_SIZE = 104;
const DEFAULT_FONT_SIZE = 12;
const getLineBreak = memoize(text => {
  return text && text.split(' ').length > 0 ? 'normal' : 'break-all';
});
const getTextPadding = memoize((text, tileSize) => {
  const shouldAddIconTextSpace = tileSize && tileSize < DEFAULT_TILE_SIZE && getLineBreak(text) === 'normal';
  return shouldAddIconTextSpace ? '5px 5px 0px 5px' : '0 5px';
});
const ChildWrapper = styled.div.withConfig({
  displayName: "EPAddableTile__ChildWrapper",
  componentId: "sc-1dirlvv-0"
})([".hs-private.hs-private.hs-private &{color:", ";bottom:5px;font-weight:400;position:absolute;width:100%;padding:", ";text-align:center;height:27px;line-height:initial;font-size:", "px;display:flex;align-items:center;justify-content:center;word-break:", ";hyphens:auto;}.hs-private.hs-private.hs-private & p{margin-bottom:0;}"], OBSIDIAN, props => getTextPadding(props.text, props.tileSize), props => props.textSize ? props.textSize : DEFAULT_FONT_SIZE, props => getLineBreak(props.text));
const DragHandleWrapper = styled.div.withConfig({
  displayName: "EPAddableTile__DragHandleWrapper",
  componentId: "sc-1dirlvv-1"
})([".hs-private.hs-private.hs-private &{margin-top:6px;text-align:center;}"]);
const IconWrapper = styled.div.withConfig({
  displayName: "EPAddableTile__IconWrapper",
  componentId: "sc-1dirlvv-2"
})([".hs-private.hs-private.hs-private &{margin-top:12px;line-height:1;line-height:initial;text-align:center;}.hs-private.hs-private.hs-private & >:first-child{margin:0 auto;}"]);
const DEFAULT_MAX_CHARS = 23;
const Wrapper = styled.div.withConfig({
  displayName: "EPAddableTile__Wrapper",
  componentId: "sc-1dirlvv-3"
})([".hs-private.hs-private.hs-private &{border-radius:4px;position:relative;border:1px solid ", ";height:", "px;width:", "px;background-color:", ";color:", ";cursor:move;cursor:grab;}"], BATTLESHIP, props => props.tileSize ? props.tileSize : DEFAULT_TILE_SIZE, props => props.tileSize ? props.tileSize : DEFAULT_TILE_SIZE, props => props.useOnDark ? OLAF : CIRRUS, EERIE);
class EPAddableTile extends Component {
  render() {
    const {
      iconNode,
      text,
      className,
      _bodyElement,
      hideTooltip,
      maxTooltipWidth,
      useOnDark,
      tileSize,
      textSize,
      maxChars,
      'data-test-id': dataTestId
    } = this.props;
    const icon = iconNode || /*#__PURE__*/_jsx(UIIcon, {
      name: 'customModules'
    });
    const disableTooltip = hideTooltip || text && text.length <= maxChars;
    return /*#__PURE__*/_jsxs(Wrapper, {
      className: className,
      useOnDark: useOnDark,
      tileSize: tileSize,
      "data-test-id": dataTestId,
      children: [/*#__PURE__*/_jsx(DragHandleWrapper, {
        children: /*#__PURE__*/_jsx(EPDragHandle, {
          color: EERIE
        })
      }), /*#__PURE__*/_jsx(IconWrapper, {
        children: icon
      }), /*#__PURE__*/_jsx(ChildWrapper, {
        textSize: textSize,
        text: text,
        tileSize: tileSize,
        children: /*#__PURE__*/_jsx(UITooltip, {
          title: text,
          autoPlacement: false,
          placement: 'bottom',
          maxWidth: maxTooltipWidth,
          _bodyElement: _bodyElement,
          delay: 0,
          disabled: disableTooltip,
          children: /*#__PURE__*/_jsx(UITruncateMultiline, {
            maxChars: maxChars,
            text: text
          })
        })
      })]
    });
  }
}
EPAddableTile.propTypes = {
  text: PropTypes.string.isRequired,
  maxTooltipWidth: PropTypes.number.isRequired,
  className: PropTypes.string,
  iconNode: PropTypes.node,
  useOnDark: PropTypes.bool.isRequired,
  _bodyElement: PropTypes.object,
  hideTooltip: PropTypes.bool.isRequired,
  tileSize: PropTypes.number,
  textSize: PropTypes.number,
  maxChars: PropTypes.number,
  'data-test-id': PropTypes.string
};
EPAddableTile.defaultProps = {
  maxTooltipWidth: 130,
  hideTooltip: false,
  useOnDark: false,
  maxChars: DEFAULT_MAX_CHARS
};
export default EPAddableTile;